<template>
  <v-container>
    <div class="mb-12">
      <v-toolbar
        dense
        color="primary"
        elevation="0"
        dark
        class="mx-auto fixed-bar mt-n2"
        style="max-width: 1340px"
      >
        <v-toolbar-title class="d-none d-md-flex">
          CARRITO DE COMPRAS
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-autocomplete
          auto-select-first
          background-color="white"
          color="primary"
          :class="['mx-auto', 'rounded-lg']"
          clearable
          cache-items
          flat
          hide-details
          hide-no-data
          hide-selected
          item-color="primary"
          item-text="Nombre"
          item-value="Codigo"
          :items="items"
          light
          dense
          :loading="isLoading ? '#D3BC8D' : null"
          placeholder="Buscar Articulo para Agregar al Carrito"
          :search-input.sync="search"
          solo
          style="max-width: 600px"
          v-model="model"
        ></v-autocomplete>
        <v-spacer></v-spacer>
        <v-chip
          class="d-none d-md-flex ma-2"
          v-if="Object.values(Pedido.items).length !== 0"
          color="success-500"
          label
          text-color="primary"
          link
          @click="dialogTrans = true"
        >
          <v-icon left> mdi-check-circle-outline </v-icon>
          {{ title }}
        </v-chip>
      </v-toolbar>
      <v-row v-if="errorBuscar">
        <MensajeError
          :mensaje="`Se produjo un Error  Procesando la Consulta, 
          detalle => ${erroredData}`"
        />
   
      </v-row>

      <v-overlay :value="CarOverlay">
        <v-alert width="300" :class="['mx-auto']" :type="CarMsj.Type">
          {{ CarMsj.Msj }}
        </v-alert>
      </v-overlay>
      <ResumenShop v-if="$vuetify.breakpoint.smAndDown" />
      <InfoEmbajale v-if="$vuetify.breakpoint.smAndDown" />
      <v-btn
        v-if="
          $vuetify.breakpoint.smAndDown &&
          Object.values(Pedido.items).length !== 0
        "
        class="ma-2 mx-auto"
        color="accent"
        block
        elevation="0"
        @click="dialogTrans = true"
      >
        <v-icon left> mdi-check-circle-outline </v-icon>
        {{ title }}
      </v-btn>
      <CarritoVue v-if="$vuetify.breakpoint.smAndDown" />
      <v-data-table
        v-if="
          Object.values(Pedido.items).length !== 0 &&
          $vuetify.breakpoint.mdAndUp
        "
        color="primary"
        :headers="PedHeaders"
        :items="Pedido.items"
        :items-per-page="15"
        :class="['elevation-1', 'mx-auto', 'mt-3']"
        style="max-width: 1340px"
        :loading="loading"
        mobile-breakpoint="0"
      >
        <template v-slot:item="{ item }">
          <ItemCar :item="item" />
        </template>
        <template slot="body.append">
          <tr v-if="Pedido.data.Descuento !== 0">
            <th colSpan="2">
             <InfoEmbajale />
            </th>
            <th v-for="n in 3" :key="n"></th>
            <th class="text-right text-subtitle-2 font-weight-bold">
              Sub Total :
            </th>
            <th class="text-right text-subtitle-2 font-weight-bold">
              {{ simboloMoneda[tipoMoneda] }}
              {{ Pedido.data.MontoBruto[tipoMoneda] | numeral("0,0.00") }}
            </th>
          </tr>
          <tr v-if="Pedido.data.Descuento !== 0">
            <th v-for="n in 5" :key="n"></th>
            <th class="text-right text-subtitle-2 font-weight-bold">
              Descuento {{ Pedido.data.Descuento | numeral("0,0.00") }}% :
            </th>
            <th class="text-right text-subtitle-2 font-weight-bold">
              {{ simboloMoneda[tipoMoneda] }}
              {{ Pedido.data.MontoDes[tipoMoneda] | numeral("0,0.00") }}
            </th>
          </tr>
          <tr>
            <th v-for="n in 5" :key="n"></th>
            <th class="text-right text-subtitle-2 font-weight-bold">
              Total Neto :
            </th>
            <th class="text-right text-subtitle-2 font-weight-bold">
              {{ simboloMoneda[tipoMoneda] }}
              {{ Pedido.data.MontoNeto[tipoMoneda] | numeral("0,0.00") }}
            </th>
          </tr>
          <tr v-if="Pedido.data.MontoIva[tipoMoneda] !== 0">
            <th v-for="n in 5" :key="n"></th>
            <th class="text-right text-subtitle-2 font-weight-bold">
              Total IVA :
            </th>
            <th class="text-right text-subtitle-2 font-weight-bold">
              {{ simboloMoneda[tipoMoneda] }}
              {{ Pedido.data.MontoIva[tipoMoneda] | numeral("0,0.00") }}
            </th>
          </tr>
          <tr>
            <th v-for="n in 5" :key="n"></th>
            <th class="text-right text-subtitle-1 font-weight-black">
              TOTAL PEDIDO :
            </th>
            <th class="text-right text-subtitle-1 font-weight-black">
              {{ simboloMoneda[tipoMoneda] }}
              {{ Pedido.data.MontoTotal[tipoMoneda] | numeral("0,0.00") }}
            </th>
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="dialogTrans" persistent max-width="500">
        <v-card :loading="loading" class="elevation-0" color="warning">
          <v-toolbar dark flat color="white">
            <v-toolbar-title :class="['d-none', 'd-sm-none', 'd-md-flex']">
              <v-img
                contain
                :src="`${domoapi2_img}Cia/15/logo?archivo=1.png`"
                id="Home"
                width="154"
              />
            </v-toolbar-title>

            <v-container>
              <v-layout row>
                <v-toolbar-title :class="['mx-auto']">
                  CONFIRMAR PEDIDO
                </v-toolbar-title>
              </v-layout>
            </v-container>
            <v-btn icon @click="dialogTrans = false" color="primary">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-form>
            <v-card :class="['ma-5', 'mx-5', 'elevation-0']">
              <v-card-text
                :class="[
                  'text-xs-subtitle-2',
                  'text-sm-subtitle-2',
                  'text-md-subtitle-1',
                  'text-lg-subtitle-1',
                  'text-xl-subtitle-1',
                ]"
              >
                Complete los siguientes campos
              </v-card-text>
              <v-select
                v-model="paramConfirmar.transporte"
                :items="Pedido.transporte"
                item-text="Nombre"
                item-value="Codigo"
                label="Transporte"
                dense
                outlined
                :class="['ma-2']"
              />

              <v-text-field
                v-model="paramConfirmar.refere"
                label="Referencia"
                outlined
                :class="['mx-2']"
              />

              <v-textarea
                v-model="paramConfirmar.notas"
                name="input-7-1"
                label="Observaciones"
                outlined
                :class="['mx-2']"
              />

              <v-checkbox
                v-if="dataUser.TipoUsuario === 'U'"
                v-model="paramConfirmar.presupuesto1"
                label="Cargar como presupuesto"
                :class="['mx-2']"
              />
            </v-card>
            <v-divider color="#D3BC8D" />
            <v-card-actions style="position: relative">
              <v-btn
                color="primary"
                dark
                @click="confirmar"
                :class="['mx-auto']"
              >
                CONFIRMAR
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogDetalle"
        :max-width="$vuetify.breakpoint.smAndDown ? 400 : 290"
        persistent
      >
        <v-card
          v-if="Articulo.length !== 0"
          class="elevation-12"
          color="warning"
        >
          <v-toolbar dark flat color="white">
            <v-toolbar-title :class="['d-none', 'd-sm-none', 'd-md-flex']">
              <v-img
                contain
                :src="`${domoapi2_img}Cia/15/logo?archivo=1.png`"
                id="Home"
                width="154"
              ></v-img>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn
              light
              icon
              @click="
                model = null;
                dialogShow = false;
              "
            >
              <v-icon color="primary">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-row no-gutters>
            <v-col>
              <v-card color="transparent" :class="['mx-5', 'my-5']">
                <CardProducto :item="Articulo" :verbtn="true" :key="idDialog" />
              </v-card>
            </v-col>
          </v-row>

          <v-divider color="#D3BC8D"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" elevation="0" @click="model = null">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card
        v-if="Object.values(Pedido.items).length === 0"
        :class="['mx-auto', 'elevation-0', 'mt-10', 'text-center']"
        width="250px"
        outlined
      >
        <v-card-title class="font-weight-bold"
          >Tu Carrito está vacío</v-card-title
        >
        <v-icon size="50">mdi-cart-variant</v-icon>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import MensajeError from "@/components/MensajeError";
import ItemCar from "@/components/ItemCar";
import CarritoVue from "@/components/CarritoMovil/Carrito";
import { ResumenShop } from "@/components/DrawerCar";
import CardProducto from "@/components/ItemGrid/CardProducto";
import InfoEmbajale from "@/components/CarritoMovil/InfoEmbajale"

export default {
  name: "CarritoCompras",
  data: () => ({
    Articulo: [],
    title: "CONFIRMAR PEDIDO",
    Promocion: [],
    nombreLimit: 60,
    entries: [],
    isLoading: false,
    model: null,
    search: null,
    dialogShow: false,
    errorBuscar: false,
    idDialog: 0,
    DetalleArt: {
      Articulo: "",
      Cantidad: 1,
      Promo: 0,
      PromoPos: 0,
    },
    PedHeaders: [
      {
        text: "Producto",
        value: "Codigo",
        align: "center",
        sortable: true,
        divider: true,
        width: 120,
        class: ["text-subtitle-2", "font-weight-bold"],
      },
      {
        text: "Descripción",
        value: "Nombre",
        align: "center",
        sortable: true,
        divider: true,
        class: ["text-subtitle-2", "font-weight-bold"],
      },
      {
        text: "P. Unit",
        align: "center",
        divider: true,
        sortable: true,
        value: "Precio",
        class: ["text-subtitle-2", "font-weight-bold"],
      },
      {
        text: "Dcto",
        align: "center",
        divider: true,
        sortable: true,
        value: "Descuento",
        class: ["text-subtitle-2", "font-weight-bold"],
      },
      {
        text: "P. Neto",
        align: "center",
        divider: true,
        sortable: true,
        value: "PrecioNeto",
        class: ["text-subtitle-2", "font-weight-bold"],
      },
      {
        text: "Cantidad",
        align: "center",
        divider: true,
        sortable: true,
        value: "Cantidad",
        class: ["text-subtitle-2", "font-weight-bold"],
      },
      {
        text: "P. Total",
        align: "center",
        divider: true,
        sortable: true,
        value: "PrecioTot",
        class: ["text-subtitle-2", "font-weight-bold"],
      },
    ],
    paramConfirmar: {
      transporte: 1,
      refere: "",
      notas: "",
      presupuesto1: false,
      confimar_pedido: "si",
      opc: 10,
    },
    dialogTrans: false,
  }),
  components: {
    MensajeError,
    ItemCar,
    CarritoVue,
    ResumenShop,
    CardProducto,
    InfoEmbajale
  },
  methods: {
    ...mapMutations([
      "ERROR_AXIOS",
      "ERROR_DATA",
      "CLR_PROMO",
      "CLR_DATOS_ART",
      "set_mensaje",
      "clearToken",
    ]),
    ...mapActions([
      "cargarDatosPromo",
      "get_ConsultaPedido",
      "set_cargaArtCarrito",
      "get_confirmarPedido",
      "get_BuscaArticulo",
    ]),
    async searchTxt({ txt }) {
      if (txt === null) return;
      if (txt.length < 3) return;
      if (this.entries == []) return;
      if (this.dialogDetalle) return;

      try {
        let ttArticulo = [];
        this.isLoading = true;
        if (await this.get_BuscaArticulo(txt)) {
          ttArticulo = this.filterconsolidado;
        }
        this.count = ttArticulo.length;
        this.entries = ttArticulo;
      } catch (error) {
        // console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async detalleArticulo(codigo) {
      let that = this;
      let CantPed = this.Pedido.items
        .filter((x) => x.Codigo === codigo)
        .map((x) => x.Cantidad);
      this.errorBuscar = false;
      this.Articulo = this.filterconsolidado.filter(
        (x) => x.Codigo === codigo
      )[0];
   
      this.DetalleArt.Articulo = this.Articulo.Codigo;
      this.DetalleArt.Cantidad =
        CantPed.length !== 0 ? CantPed[0] : this.Articulo.Cantidad;
      this.dialogShow = true;
    },
    articuloRoute(codart) {
      this.CLR_PROMO();
      this.CLR_DATOS_ART();
      this.cargarDatosPromo({ codart: codart });
      codart = encodeURIComponent(codart);
      this.$vuetify.goTo(0);
      return this.$router.push("/articulo/" + codart);
    },
    async CargarItem() {
      await this.set_cargaArtCarrito({
        articulo: this.DetalleArt.Articulo,
        cantidad: this.DetalleArt.Cantidad,
        promo: this.DetalleArt.Promo,
      });
      this.model = null;
      await this.get_ConsultaPedido();
      this.set_mensaje({
        Visible: true,
        Msj: "Articulo Cargado",
        Type: "success",
      });
    },
    submitPed(e) {
      e.preventDefault;
      let xTime = new Date();

      setTimeout(() => {
        xTime = new Date();
      }, 1000);
    },
    fetchEntriesDebounced() {
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.searchTxt({ txt: this.search });
      }, 500); /* 500ms throttle */
    },
    clearEntries() {
      this.count = 0;
      this.entries = [];
    },
    async confirmar() {
      this.dialogTrans = false;
      await this.get_confirmarPedido(this.paramConfirmar);
      this.paramConfirmar = {
        transporte: 1,
        refere: "",
        notas: "",
        presupuesto1: false,
        confimar_pedido: "si",
        opc: 10,
      };

      this.$vuetify.goTo(0);
      return this.$router.push("/");
    },
  },
  computed: {
    ...mapState([
      "dataUser",
      "Cliente",
      "Pedido",
      "tipoMoneda",
      "simboloMoneda",
      "errored",
      "loading",
      "CarOverlay",
      "CarMsj",
      "PromocionAll",
      "domoapi2_img",
    ]),
    ...mapGetters([
      "filterconsolidado",
      "filterscat",
      "filterMarcaPdf",
      "filtermarca",
    ]),
    validaUser() {
      if (this.dataUser.IndAutenticado && !this.Cliente.showOpc) return true;
      else {
        this.$router.push({ path: `/` }).catch((err) => {});
        return false;
      }
    },
    dialogDetalle() {
      if (!this.model) return false;

      this.DetalleArt = {
        Articulo: "",
        Cantidad: 1,
        Promo: 0,
        PromoPos: 0,
      };
      this.idDialog++;
      this.detalleArticulo(this.model);
      this.entries = [];

      return this.dialogShow;
    },
    items() {
      if (this.entries.length === 0) return [];
      else {
        return this.entries.map((entry) => {
          const Nombre =
            entry.Nombre.length > this.nombreLimit
              ? entry.Codigo +
                " - " +
                entry.Nombre.slice(0, this.nombreLimit) +
                "..."
              : entry.Codigo + " - " + entry.Nombre;

          return Object.assign({}, entry, { Nombre });
        });
      }
    },
    ValidaCantidad() {
      let Promociones = this.Promocion,
        xCantidad = this.DetalleArt.Cantidad,
        CodigoPromo = "",
        PromoRangos = [
          {
            Codigo: 0,
            min: 1,
            max: 1,
            pos: 0,
          },
        ];

      if (this.Articulo.length !== 0) {
        PromoRangos[0].min = this.Articulo.Cantidad;
        PromoRangos[0].max = this.Articulo.Cantidad;
        if (this.Articulo.Promocion) {
          let i = 0;
          Promociones.forEach(function (x) {
            PromoRangos.push({
              Codigo: x.Codigo,
              min: x.Cantidad,
              max: x.Cantidad,
              pos: i,
            });

            PromoRangos[i].max = x.Cantidad;
            i++;
          });
        }
      }

      CodigoPromo = PromoRangos.filter((r) =>
        r.min !== r.max
          ? xCantidad >= r.min && xCantidad < r.max
          : xCantidad >= r.min
      );
      this.DetalleArt.Promo = CodigoPromo[0].Codigo;
      this.DetalleArt.PromoPos = CodigoPromo[0].pos;

      return this.DetalleArt.Promo === 0 ? false : true;
    },

  },
  watch: {
    validaUser() {
      this.validaUser;
    },
    async search(val) {
      if (val === null) return;
      if (val.length < 3) return;
      if (this.entries == []) return;

      this.clearEntries();

      this.fetchEntriesDebounced();
    },
    $route(to, from) {
  
      this.get_ConsultaPedido();
    },
    deep: true,
    immediate: true,
  },
  created() {
    this.get_ConsultaPedido();
  },
};
</script>

<style>
td {
  vertical-align: top;
}
@media screen and (max-width: 991px) {
  .container {
    display: block;
  }
}

@media screen and (max-width: 767px) {
  .container {
    display: block;
  }
}

.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 6.5em;
  z-index: 2;
}
</style>
